import type { Messages } from './en';

export const pt: Messages = {
  'nav.clientHub': 'Portal do Cliente',
  'nav.menu': 'Menu',
  'nav.home': 'Início',
  'nav.products': 'Produtos',
  'nav.liveCasino': 'Casino ao vivo',
  'nav.slots': 'Slots',
  'nav.tableGames': 'Jogos de mesa',
  'nav.library': 'Biblioteca',
  'nav.roadmap': 'Roadmap',
  'nav.assets': 'Recursos',
  'nav.guidelines': 'Diretrizes',
  'nav.account': 'Conta',
  'nav.signOut': 'Terminar sessão',
  'nav.categoriesAria': 'Categorias de jogos',
  'nav.sectionsAria': 'Secções principais',
  'nav.brandAria': 'RichyPlay Portal do Cliente',
  'nav.comingSoon': 'Brevemente',
  'nav.soon': 'Em breve',

  'lang.label': 'Idioma',
  'lang.select': 'Selecionar idioma',

  'category.live': 'Ao vivo',
  'category.slot': 'Slots',
  'category.instant': 'Instantâneos',
  'category.table': 'Mesa',

  'status.planned': 'Planeado',
  'status.in_progress': 'Em curso',
  'status.shipped': 'Lançado',
  'status.available': 'Disponível',
  'status.coming_soon': 'Brevemente',
  'status.maintenance': 'Manutenção',

  'common.error': 'Algo correu mal',
  'common.checkingSession': 'A verificar a sessão…',
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.none': 'Nenhum',
  'common.active': 'Ativo',
  'common.inactive': 'Inativo',

  'home.eyebrow': 'Portal do operador',
  'home.title': 'Portal do Cliente',
  'home.lead':
    'Explore o portefólio da RichyPlay — lance demos, acompanhe o roadmap e descarregue recursos de marca num único espaço de trabalho.',
  'home.enterLibrary': 'Entrar na biblioteca',
  'home.viewRoadmap': 'Ver roadmap',
  'home.browse': 'Explorar por categoria',
  'home.openLibrary': 'Abrir biblioteca',

  'library.eyebrow': 'Biblioteca de jogos',
  'library.title': 'Portefólio',
  'library.liveTitle': 'Portefólio de casino ao vivo',
  'library.slotTitle': 'Portefólio de slots',
  'library.liveLead': 'Escolha um produto ao vivo. Blackjack e Roulette estão ativos; o resto chega em breve.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': 'Pesquise e filtre o catálogo RichyPlay. Lance demos num novo separador.',
  'library.search': 'Pesquisar jogos…',
  'library.statusFilterAria': 'Filtrar por estado',
  'library.statusAll': 'Todos os estados',
  'library.loading': 'A carregar jogos…',
  'library.unavailableTitle': 'Biblioteca indisponível',
  'library.unavailableMessage':
    'Não foi possível carregar a biblioteca de jogos. O catálogo pode estar indisponível.',
  'library.apiFailedMessage':
    'Não conseguimos contactar a API do catálogo. Tente mais tarde ou contacte o suporte.',
  'library.emptyTitle': 'Nenhum jogo encontrado',
  'library.emptyMessage': 'Experimente outra pesquisa ou filtro de categoria.',
  'library.viewGame': 'Ver jogo',

  'game.loading': 'A carregar jogo…',
  'game.notFound': 'Jogo não encontrado.',
  'game.back': 'Voltar',
  'game.breadcrumbAria': 'Trilho de navegação',
  'game.liveCasino': 'Casino ao vivo',
  'game.slots': 'Slots',
  'game.demoFrameTitle': 'Demo de {title}',
  'game.startingDemo': 'A iniciar sessão de demo…',
  'game.demoNotStarted': 'Não foi possível iniciar a sessão de demo.',
  'game.demoBadge': 'Modo demo',
  'game.blockedMaintenance': 'Este jogo está em manutenção.',
  'game.blockedComingSoon': 'Brevemente — a demo ainda não foi publicada.',
  'game.blockedNoDemo': 'O catálogo do operador não disponibiliza uma versão demo deste título.',
  'game.currency': 'Moeda',
  'game.language': 'Idioma',
  'game.reloadDemo': 'Recarregar demo',
  'game.startDemo': 'Iniciar demo',
  'game.openNewTab': 'Abrir num novo separador',
  'game.copyLink': 'Copiar ligação',
  'game.copied': 'Copiado',
  'game.demoFailedTitle': 'Falha ao iniciar a demo',
  'game.demoUrlMissing': 'O servidor não devolveu o URL de lançamento.',
  'game.demoFailed': 'Não foi possível iniciar a demo.',
  'game.highlighted': 'Destacado',
  'game.features': 'Funcionalidades do jogo',
  'game.keyFeatures': 'Principais características',
  'liveTable.title': 'Mesas disponíveis',
  'liveTable.totalResults': 'Resultados totais:',
  'liveTable.download': 'Descarregar dados da mesa',
  'liveTable.gameId': 'ID do jogo',
  'liveTable.tableName': 'Nome da mesa',
  'liveTable.minLimit': 'Limite mínimo',
  'liveTable.maxLimit': 'Limite máximo',
  'liveTable.hours': 'Horário de operação UTC',
  'liveTable.language': 'Idioma de operação',
  'liveTable.releaseDate': 'Data de lançamento',
  'liveTable.location': 'Localização',
  'game.betLevels': 'Níveis de aposta',
  'game.tableRules': 'Regras da mesa',
  'game.mathConfig': 'Configuração matemática',
  'game.resources': 'Recursos',
  'game.relatedAssets': 'Recursos relacionados',
  'game.releaseRoadmap': 'Roadmap de lançamentos',
  'game.integrationGuidelines': 'Diretrizes de integração',
  'game.information': 'Informação do jogo',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Ambiente de trabalho',
  'game.platformTablet': 'Tablet',
  'game.platformMobile': 'Telemóvel',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'A ficha de dados do jogo será adicionada em breve.',

  'spec.numericId': 'ID numérico',
  'spec.minBetPerLine': 'Aposta mínima por linha',
  'spec.minTotalBet': 'Aposta total mínima',
  'spec.maxTotalBet': 'Aposta total máxima',
  'spec.maxTotalBetAnte': 'Aposta total máx. com Ante',
  'spec.reels': 'Rolos',
  'spec.rows': 'Linhas',
  'spec.payType': 'Tipo de pagamento',
  'spec.payLinesValue': '{count} linhas',
  'spec.symbolPays': 'Pagamentos por símbolo',
  'spec.betMultiplier': 'Multiplicador de aposta',
  'spec.maxMultiplierWin': 'Ganho máx. do multiplicador',
  'spec.maxExposure': 'Exposição máxima',
  'spec.bonusBuyX': 'Compra de bónus X',
  'spec.anteBetX': 'Aposta Ante X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': 'Frequência de prémios',
  'spec.oneIn': '1 em {value}',
  'spec.hasReplay': 'Replay',
  'spec.hasBuySpins': 'Compra de rodadas',
  'spec.hasInstantBonus': 'Bónus instantâneo',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Aposta Ante',
  'spec.releaseDate': 'Data de lançamento',
  'spec.symbol': 'Símbolo do jogo',
  'spec.referenceId': 'ID de referência',
  'spec.provider': 'Fornecedor',
  'spec.product': 'Produto',
  'spec.gameType': 'Tipo de jogo',
  'spec.category': 'Categoria',
  'spec.theme': 'Tema',
  'spec.technology': 'Tecnologia',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Volatilidade',
  'spec.maxWin': 'Ganho máximo',
  'spec.paylines': 'Linhas de pagamento',
  'spec.grid': 'Grelha',
  'spec.bonusFrequency': 'Frequência de bónus',
  'spec.bonusFrequencyValue': '1 em {value}',
  'spec.jackpot': 'Jackpot',
  'spec.betRange': 'Intervalo de aposta',
  'spec.defaultBet': 'Aposta predefinida',
  'spec.currency': 'Moeda',
  'spec.languages': 'Idiomas',
  'spec.demoAvailable': 'Demo disponível',
  'spec.tournaments': 'Torneios',
  'spec.highlighted': 'Destacado',
  'spec.status': 'Estado',
  'spec.version': 'Versão',
  'spec.lastUpdated': 'Última atualização',

  'roadmap.eyebrow': 'Roadmap do produto',
  'roadmap.title': 'O que se segue',
  'roadmap.lead': 'Acompanhe os próximos lançamentos e os títulos já lançados por categoria.',
  'roadmap.bannerAria': 'Próximos lançamentos',
  'roadmap.soonTitle': 'Em breve',
  'roadmap.loading': 'A carregar roadmap…',
  'roadmap.error': 'Não foi possível carregar os itens do roadmap.',
  'roadmap.emptyTitle': 'Sem itens no roadmap',
  'roadmap.emptyMessage': 'Ainda não existem entradas publicadas para esta categoria.',
  'roadmap.itemCount': '{count} itens',
  'roadmap.target': 'Meta: {date}',
  'roadmap.viewInLibrary': 'Ver na biblioteca',

  'upcoming.title': 'Próximos lançamentos',
  'upcoming.playDemo': 'Jogar demo',
  'upcoming.prev': 'Lançamentos anteriores',
  'upcoming.next': 'Próximos lançamentos',

  'assets.eyebrow': 'Recursos de marca',
  'assets.title': 'Pacotes de recursos',
  'assets.lead':
    'Descarregue logótipos, artes principais e materiais de marketing. Consulte {link} para as regras de utilização.',
  'assets.leadLink': 'as diretrizes de recursos',
  'assets.loading': 'A carregar recursos…',
  'assets.error': 'Não foi possível carregar os pacotes de recursos.',
  'assets.downloadFailed': 'Falha na transferência.',
  'assets.emptyTitle': 'Ainda sem recursos',
  'assets.emptyForGame': 'Não há pacotes de recursos associados a este jogo.',
  'assets.emptyGeneral': 'Os pacotes de recursos aparecerão aqui quando forem publicados.',
  'assets.pack': 'Pacote',
  'assets.updated': 'Atualizado a {date}',
  'assets.download': 'Descarregar',
  'assets.search': 'Pesquisar pelo nome do jogo…',
  'assets.searchEmpty': 'Nenhum jogo corresponde a esse nome.',

  'guidelines.eyebrow': 'Documentação',
  'guidelines.title': 'Diretrizes',
  'guidelines.lead': 'Notas de integração, utilização de recursos e referências para operadores.',
  'guidelines.all': 'Todas',
  'guidelines.integration': 'Integração',
  'guidelines.assets': 'Recursos',
  'guidelines.loading': 'A carregar diretrizes…',
  'guidelines.error': 'Não foi possível carregar as diretrizes.',
  'guidelines.emptyTitle': 'Sem diretrizes',
  'guidelines.emptyMessage': 'As diretrizes publicadas aparecerão aqui.',
  'guidelines.index': 'Índice',
  'guidelines.navAria': 'Navegação de diretrizes',
  'guidelines.articleLoading': 'A carregar artigo…',
  'guidelines.notFound': 'Diretriz não encontrada.',
  'guidelines.notFoundShort': 'Não encontrado',
  'guidelines.updated': 'Atualizado a {date}',
  'guidelines.external': 'O conteúdo está alojado externamente.',
  'guidelines.openDocument': 'Abrir documento',
  'guidelines.typeGuide': 'Guia',
  'guidelines.typeGuideline': 'Diretriz',

  'account.eyebrow': 'A sua conta',
  'account.title': 'Perfil',
  'account.email': 'E-mail',
  'account.language': 'Idioma da interface',
  'account.recentActivity': 'Atividade recente',
  'account.loadingActivity': 'A carregar atividade…',
  'account.activityUnavailable': 'A atividade recente não está disponível neste momento.',
  'account.noActivity': 'Nenhuma atividade recente registada.',

  'event.login': 'Sessão iniciada',
  'event.logout': 'Sessão terminada',
  'event.libraryView': 'Biblioteca vista',
  'event.gameView': 'Jogo visto',
  'event.demoLaunch': 'Demo iniciada',
  'event.demoLaunchFailed': 'Falha ao iniciar a demo',
  'event.assetDownload': 'Recurso descarregado',
  'event.guidelineView': 'Diretriz vista',
  'event.roadmapView': 'Roadmap visto',

  'auth.title': 'Portal do Cliente',
  'auth.subtitle': 'Inicie sessão com as suas credenciais de operador',
  'auth.email': 'E-mail',
  'auth.password': 'Palavra-passe',
  'auth.rememberMe': 'Lembrar-me',
  'auth.signIn': 'Iniciar sessão',
  'auth.signInFailed': 'Falha ao iniciar sessão',
  'auth.signInError':
    'Não foi possível iniciar sessão. Verifique as suas credenciais e tente novamente.',
  'auth.forgotPassword': 'Esqueceu-se da palavra-passe?',
  'auth.inviteOnly': 'Acesso apenas por convite. Contacte o seu representante RichyPlay.',
  'auth.visitSiteAria': 'Ir para richyplay.live',

  'footer.navAria': 'Rodapé',
  'footer.tagline': 'Portal de operadores para o catálogo de slots e casino ao vivo RichyPlay.',
  'footer.rights': 'Todos os direitos reservados.',
  'footer.legal':
    'Acesso por convite para operadores licenciados. Apenas para uso profissional.',

  'forgot.eyebrow': 'Reposição de palavra-passe',
  'forgot.title': 'Palavra-passe esquecida',
  'forgot.requestSubtitle':
    'Introduza o seu e-mail e enviaremos um código de verificação se existir uma conta.',
  'forgot.sendCode': 'Enviar código',
  'forgot.sendError': 'Não foi possível enviar o código de reposição.',
  'forgot.confirmSubtitle': 'Introduza o código do seu e-mail e escolha uma nova palavra-passe.',
  'forgot.code': 'Código de verificação',
  'forgot.newPassword': 'Nova palavra-passe',
  'forgot.update': 'Atualizar palavra-passe',
  'forgot.updateError': 'Não foi possível repor a palavra-passe.',
  'forgot.doneSubtitle': 'A sua palavra-passe foi atualizada. Já pode iniciar sessão.',
  'forgot.backToSignIn': 'Voltar ao início de sessão',
};
